/**
 * Created by spepa on 12.01.2021
 */

const AdminConfig = {
    difficulty: {
        match3: [
            {
                bottom: 60,
                top: 95
            }
        ],

        solitaire: [
            {
                bottom: 60,
                top: 85
            },
            {
                episode: 10,
                bottom: 65,
                top: 92
            }
        ]
    }
};

AdminConfig.getConfig = function (key) {
    const config = AdminConfig[key][cleverapps.config.type];
    if (!config) {
        return;
    }

    let data;
    config.forEach((item) => {
        if (!item.episode || item.episode <= cleverapps.administrator.adminEpisodes.getActive().episodeNo) {
            data = item;
        }
    });
    return data;
};